import { NCNode, PositioningOutputSnapshot } from '../../../../src/commonTypes';

export type SynthesiseNodeInputContent = {
	label: string;
	value?: string;
	src?: string;
	type: string;
};

const addUniqueLine = (lines: string[], value: string | null | undefined): void => {
	const trimmed = value?.trim();
	if (!trimmed) return;
	if (lines.some((line) => line.toLocaleLowerCase() === trimmed.toLocaleLowerCase())) return;
	lines.push(trimmed);
};

const positioningOutputText = (output: PositioningOutputSnapshot): string => {
	const lines: string[] = [];
	addUniqueLine(lines, output.title);
	addUniqueLine(lines, output.subtitle);
	addUniqueLine(lines, output.summary);
	for (const detail of output.details) {
		const value = detail.value?.trim();
		if (!value) continue;
		addUniqueLine(lines, detail.title?.trim() ? `${detail.title}: ${value}` : value);
	}
	return lines.join('\n');
};

/**
 * Returns the human-readable content represented by a board node. Structured
 * positioning cards keep their display data outside the legacy node label, so
 * the Synthesise panel must read the snapshot rather than submitting a blank
 * (or truncated fallback) input.
 */
export const getSynthesiseNodeInputContent = (node: NCNode): SynthesiseNodeInputContent => {
	const output = node.positioningOutput;
	if (output) {
		return {
			label: output.title || node.label || output.eyebrow || 'Board output',
			value: positioningOutputText(output) || node.label || undefined,
			src: output.imageUrl || node.src,
			type: [output.type, output.lane, output.eyebrow, ...(node.topics || [])]
				.filter(Boolean)
				.join(' '),
		};
	}

	return {
		label: node.label || (node.isVideo ? 'Video reference' : node.src ? 'Image reference' : 'Board item'),
		value: node.label || undefined,
		src: node.src,
		type: [...(node.topics || []), node.synthesiseRecipe?.task || ''].filter(Boolean).join(' '),
	};
};
